import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-filter-search',
  templateUrl: './filter-search.component.html',
  styleUrls: ['./filter-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterSearchComponent implements OnInit,OnChanges {
  @Input() placeholder: string;
  @Input() value: string = '';
  @Output() search: EventEmitter<string> = new EventEmitter<string>();
  searchFormControl: FormControl;
  constructor(private formBuilder: FormBuilder) {
    this.searchFormControl = this.formBuilder.control({});
  }

  ngOnInit(): void {
    this.searchFormControl.valueChanges.pipe(
      distinctUntilChanged(),
      debounceTime(300),
    ).subscribe((value) => {
      this.search.emit(value);
    });
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if(changes?.value?.isFirstChange()) {
      this.searchFormControl.patchValue(changes.value.currentValue);
    }
  }

  public reset(): void {
    this.searchFormControl.reset('', { emitEvent: false });
  }
}
